module.exports = __webpack_public_path__ + "img/Calming Presence.e9fd261e.svg";